import { CALL_API } from "../context/constValues";
import { getAuthToken } from "../context/auth-context";
  export async function getAllMedicamentos() {
    const token = getAuthToken();
    const response = await fetch(`${CALL_API}/getallmedicamentos`, {
      headers: { Authorization: "Bearer " + token },
    });
  
    const data = await response.json();
    if (!response.ok) {
        throw new Error(`${data.messege}`);
    }
  
    return data.result;
  }
  export async function insertMedicamento(objeto) {
    const { medicamento} = objeto;

    const token = getAuthToken();
    const response = await fetch(`${CALL_API}/insertmedicamento`, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
       medicamento
      }),
    });
  
    const data = await response.json();
  
    if (!response.ok) {
      throw new Error(
        data.message ? data.message : "Error al insertar medicamento"
      );
    }
  
    return data.isSaved;
  }
  export async function updateMedicamento(objeto) {
 
    const {
     idmedicamentos,
     medicamento
    } = objeto;
    const token = getAuthToken();
    const response = await fetch(
      `${CALL_API}/updatemedicamento/${idmedicamentos}`,
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
        idmedicamento:idmedicamentos,
        medicamento
        }),
      }
    );
    const data = await response.json();
    if (!response.ok) {
        throw new Error(`${data.messege}`);
    }
  
    return data.isSaved;
  }
  export async function deleteMedicamento(id) {
    const token = getAuthToken();
    const response = await fetch(`${CALL_API}/deletemedicamento/${id}`, {
      method: "DELETE",
      headers: { Authorization: "Bearer " + token },
    });
  
    const data = await response.json();
  
    if (!response.ok) {
      throw new Error("No se encontraron Datos");
    }
  
    return data.isDeleted;
  }